/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AnalysisData } from "./AnalysisData";
export const AnalysisResponse = core.serialization.object({
    data: core.serialization.list(AnalysisData),
    meta: core.serialization.any().optional(),
});
